import { formatText } from '@/utils/helpers';
import React, { useContext, useMemo } from 'react';
import { MuiTypography } from '../material-ui';
import ElasticComponentContext from './ElasticComponentContext';

const ResultsQuantity = () => {
  const { pagination, labels = {} } = useContext(ElasticComponentContext);
  const message = useMemo(
    () => labels.showing_results || 'Showing %1 - %2 of %3 results',
    [labels.showing_results],
  );
  const paginationFrom = pagination?.totalPages === 0 ? 0 : pagination.from;
  const HTML_MESSAGE = useMemo(
    () =>
      formatText(
        message,
        [paginationFrom, pagination?.to, pagination?.totalResults].map(
          (el) => `<strong>${el}</strong>`,
        ),
      ),
    [message, paginationFrom, pagination?.to, pagination?.totalResults],
  );

  return (
    <MuiTypography
      variant="body1"
      component="span"
      dangerouslySetInnerHTML={{ __html: HTML_MESSAGE }}
    />
  );
};

export default ResultsQuantity;
